import { render, staticRenderFns } from "./batchPaymentRecord.vue?vue&type=template&id=19b45f6c&scoped=true"
import script from "./batchPaymentRecord.vue?vue&type=script&lang=js"
export * from "./batchPaymentRecord.vue?vue&type=script&lang=js"
import style0 from "./batchPaymentRecord.vue?vue&type=style&index=0&id=19b45f6c&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b45f6c",
  null
  
)

export default component.exports